import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    // faltaHora: false,
    vacaciones: false,

    id: 0,
    fechaDesde: new Date(),
    fechaHasta: new Date(),
    periodo: new Date(),
    periodoAnio: 0,
    
    horaDesde: 0,
    minutosDesde: 0,
    timeDesde: null,
    horaHasta: 0,
    minutosHasta: 0,
    timeHasta: null,

    personalId: 0,
    personal: null,
    personalNombre: null,
    tipoNovedadId: 0,
    tipoNovedad: null,
    tipoNovedadNombre: null,
    observaciones: '',
    rowVersion: null,

    /* Novedades para una lista de personal seleccionado */
    personalList: [],

    personalNovedadDatos: [],

    horario: [
        '08:00', '08:15', '08:30', '08:45',
        '09:00', '09:15', '09:30', '09:45',
        '10:00', '10:15', '10:30', '10:45',
        '11:00', '11:15', '11:30', '11:45',
        '12:00', '12:15', '12:30', '12:45',
        '13:00', '13:15', '13:30', '13:45',
        '14:00', '14:15', '14:30', '14:45',
        '15:00', '15:15', '15:30', '15:45',
        '16:00', '16:15', '16:30', '16:45',
        '17:00', '17:15', '17:30', '17:45',
        '18:00', '18:15', '18:30', '18:45',
        '19:00', '19:15', '19:30', '19:45',
        '20:00'
    ],
};

const mutations = {
    updateField,

    'INICIALIZAR' (state, params) {
        // state.faltaHora = params? params.faltaHora : false;
        state.vacaciones = params? params.vacaciones : false;

        state.id = params? params.personalNovedadId : 0;

        state.fechaDesde = moment(new Date()).format('YYYY-MM-DD');
        state.fechaHasta = moment(new Date()).format('YYYY-MM-DD');
        state.periodo = moment.utc((new Date()).getFullYear() + '-01-01').format('YYYY-MM-DD');
        state.periodoAnio = parseInt(moment.utc((new Date()).getFullYear() + '-01-01').format('YYYY'));
        
        state.horaDesde = 9;
        state.minutosDesde = 0;
        state.timeDesde = '09:00';
        state.horaHasta = 9;
        state.minutosHasta = 0;
        state.timeHasta = '09:00';

        state.personalId = 0;
        state.personal = null;
        state.personalNombre = null;
        state.tipoNovedadId = 0;
        state.tipoNovedad = null;
        state.tipoNovedadNombre = null;
        state.observaciones = '';
        state.rowVersion = null;

        state.personalList = [];

        /* Valido si paso el personal como parametro */
        if (params) {
            if (params.personal) {
                state.personalId = params.personal.id;
                state.personal = params.personal;
                state.personalNombre = params.personal.nombre.trim();
            }
        }
    },
    'SET_PERSONAL_NOVEDAD' (state, personalNovedad) {
        state.fechaDesde = moment(personalNovedad.fechaDesde).format('YYYY-MM-DD');
        state.fechaHasta = moment(personalNovedad.fechaHasta).format('YYYY-MM-DD');
        state.periodo = moment(personalNovedad.periodo).format('YYYY-MM-DD');
        state.periodoAnio = parseInt(new Date(personalNovedad.periodo).getFullYear());
        
        state.horaDesde = parseInt(new Date(personalNovedad.fechaDesde).getHours());
        state.minutosDesde = parseInt(new Date(personalNovedad.fechaDesde).getMinutes());
        state.timeDesde = String(state.horaDesde).padStart(2, '0') + ':' + String(state.minutosDesde).padStart(2, '0');
        state.horaHasta = parseInt(new Date(personalNovedad.fechaHasta).getHours());
        state.minutosHasta = parseInt(new Date(personalNovedad.fechaHasta).getMinutes());
        state.timeHasta = String(state.horaHasta).padStart(2, '0') + ':' + String(state.minutosHasta).padStart(2, '0');

        state.personalId = personalNovedad.personal? parseInt(personalNovedad.personal.id) : 0;
        state.personal = personalNovedad.personal;
        state.personalNombre = personalNovedad.personal? personalNovedad.personal.nombre.trim() : null;
        state.tipoNovedadId = personalNovedad.tipoNovedad? parseInt(personalNovedad.tipoNovedad.id) : 0;
        state.tipoNovedad = personalNovedad.tipoNovedad;
        state.tipoNovedadNombre = personalNovedad.tipoNovedad? personalNovedad.tipoNovedad.nombre.trim() : null;
        state.observaciones = personalNovedad.observaciones;
        state.rowVersion = personalNovedad.rowVersion;
    },
    'SET_PERSONAL_LISTADO' (state, personal) {
        state.personalList = personal.map(recurso => ({
            ...recurso,
            selected: false
        }))
    },
    'SET_PERSONAL'(state, personal) {
        state.personalId = personal? personal.id : 0;
        state.personal = personal;
        state.personalNombre = personal? personal.nombre.trim() : null;
    },
    'SET_TIPO_NOVEDAD'(state, tipoNovedad) {
        state.tipoNovedad = tipoNovedad;

        if (tipoNovedad) {
            state.tipoNovedadId = tipoNovedad.id? tipoNovedad.id : 0;
            state.tipoNovedadNombre = tipoNovedad.nombre? tipoNovedad.nombre.trim() : null;
    
        } else {
            state.tipoNovedadId = 0;
            state.tipoNovedadNombre = null;
        }
    },
    'SET_TIME_DESDE'(state, timeDesde) {
        state.timeDesde = timeDesde;
        let time = timeDesde.split(':');
        state.horaDesde = parseInt(time[0]);
        state.minutosDesde = parseInt(time[1]);
    },
    'SET_TIME_HASTA'(state, timeHasta) {
        state.timeHasta = timeHasta;
        let time = timeHasta.split(':');
        state.horaHasta = parseInt(time[0]);
        state.minutosHasta = parseInt(time[1]);
    },

    'INICIALIZAR_DATOS'(state) {
        state.personalNovedadDatos = [];
    },
    'SET_DATOS'(state, params) {
        state.personalNovedadDatos = params.personalNovedadDatos;
    },
};

const actions = {
    inicializar ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR', params);
            
            if (params.personalNovedadId != 0) {
                apiAxios.get('personalnovedades/' + params.personalNovedadId + '/abm' )
                    .then(res => {
                        commit('SET_PERSONAL_NOVEDAD', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })            
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let personalNovedad= {};

            /* Actualizamos el periodo */
            state.periodo = moment.utc(state.periodoAnio + '-01-01').format('YYYY-MM-DD');

            /* TipoNovedad: vacaciones */
            if (state.vacaciones) {
                state.tipoNovedadId = 1;
                state.tipoNovedad = {
                    id: 1,
                    nombre: 'vacaciones'
                };
            }

            // if (state.faltaHora) {
            //     personalNovedad= {
            //         fechaDesde: moment(state.fechaDesde)
            //             .add(state.horaDesde, 'hours')
            //             .add(state.minutosDesde, 'minutes')
            //             .format('YYYY-MM-DD HH:mm'),
            //         fechaHasta: moment(state.fechaDesde)
            //             .add(state.horaHasta, 'hours')
            //             .add(state.minutosHasta, 'minutes')
            //             .format('YYYY-MM-DD HH:mm'),
            //         periodo: moment(state.periodo).format('YYYY-MM-DD'),
            //         personalId: parseInt(state.personalId),
            //         personal: state.personal,
            //         tipoNovedadId: parseInt(state.tipoNovedadId),
            //         tipoNovedad: state.tipoNovedad,
            //         observaciones: state.observaciones.trim(),
            //     };
            // } else {
                personalNovedad= {
                    fechaDesde: moment(state.fechaDesde).format('YYYY-MM-DD'),
                    fechaHasta: moment(state.fechaHasta).format('YYYY-MM-DD'),
                    periodo: moment(state.periodo).format('YYYY-MM-DD'),
                    personalId: parseInt(state.personalId),
                    personal: state.personal,
                    tipoNovedadId: parseInt(state.tipoNovedadId),
                    tipoNovedad: state.tipoNovedad,
                    observaciones: state.observaciones.trim(),
                };
            // }

            let url = 'personalnovedades';
            if (state.id != 0) {
                url += '/' + state.id;
                personalNovedad.rowVersion = state.rowVersion;
            }
            apiAxios.post(url, personalNovedad)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    // inicializarPersonalNovedad ( { commit } ) {
    //     return new Promise((resolve, reject) => {
    //         commit('INICIALIZAR');
            
    //         /* Recuperamos el listado del personal activo */
    //         let queryString = '?fechaHasta='+ moment(new Date()).format('YYYY-MM-DD');

    //         apiAxios.get('personal/active' + queryString)
    //             .then(res => {
    //                 commit('SET_PERSONAL_LISTADO', res.data);
    //                 resolve();
    //             })
    //             .catch(error => reject(helpers.methods.getErrorMessage(error)));
    //     })            
    // },
    // savePersonalNovedad ( { state } ) {
    //     return new Promise((resolve, reject) => {
    //         let personalNovedad= {};

    //         /* Actualizamos el periodo */
    //         state.periodo = moment.utc(state.periodoAnio + '-01-01').format('YYYY-MM-DD');

    //         let personal = state.personalList
    //             .filter(recurso => recurso.selected)
    //             .map(recurso => ({
    //                 id: recurso.personalId
    //             }))
            
    //         // if (personal.lenth == 0)

    //         if (state.faltaHora) {
    //             personalNovedad= {
    //                 fechaDesde: moment(state.fechaDesde)
    //                     .add(state.horaDesde, 'hours')
    //                     .add(state.minutosDesde, 'minutes')
    //                     .format('YYYY-MM-DD HH:mm'),
    //                 fechaHasta: moment(state.fechaDesde)
    //                     .add(state.horaHasta, 'hours')
    //                     .add(state.minutosHasta, 'minutes')
    //                     .format('YYYY-MM-DD HH:mm'),
    //                 periodo: moment(state.periodo).format('YYYY-MM-DD'),
    //                 tipoNovedadId: parseInt(state.tipoNovedadId),
    //                 tipoNovedad: state.tipoNovedad,
    //                 observaciones: state.observaciones.trim(),
    //                 personal
    //             };
    //         } else {
    //             personalNovedad= {
    //                 fechaDesde: moment(state.fechaDesde).format('YYYY-MM-DD'),
    //                 fechaHasta: moment(state.fechaHasta).format('YYYY-MM-DD'),
    //                 periodo: moment(state.periodo).format('YYYY-MM-DD'),
    //                 tipoNovedadId: parseInt(state.tipoNovedadId),
    //                 tipoNovedad: state.tipoNovedad,
    //                 observaciones: state.observaciones.trim(),
    //                 personal
    //             };
    //         }

    //         apiAxios.post('personalNovedad/list', personalNovedad)
    //             .then(() => resolve())
    //             .catch(error => reject(helpers.methods.getErrorMessage(error)));
    //     })
    // },
    setPersonal: ({commit}, personal) => {
        commit('SET_PERSONAL', personal);
    },
    setTipoNovedad: ({commit}, tipoNovedad) => {
        commit('SET_TIPO_NOVEDAD', tipoNovedad);
    },
    setTimeDesde: ({commit}, timeDesde) => {
        commit('SET_TIME_DESDE', timeDesde);
    },
    setTimeHasta: ({commit}, timeHasta) => {
        commit('SET_TIME_HASTA', timeHasta);
    },
    getDatos ( { commit }, personalNovedadId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_DATOS');
    
            apiAxios.get('personalnovedades/' + personalNovedadId)
                .then(res => {
                    let personalNovedadDatos = [];
                    // if (Boolean(res.data.faltaHora)) {
                    //     personalNovedadDatos = [
                    //         { 'nombre': 'fechaDesde', 'campo': 'Desde', 'valor': res.data.fechaDesde, 'formato': 'fechaHora' },
                    //         { 'nombre': 'fechaHasta', 'campo': 'Hasta', 'valor': res.data.fechaHasta, 'formato': 'fechaHora' },
                    //         { 'nombre': 'personal', 'campo': 'Personal', 'valor': res.data.personal, 'formato': '' },
                    //         { 'nombre': 'tipoNovedad', 'campo': 'Tipo de Novedad', 'valor': res.data.tipoNovedad, 'formato': '' },
                    //         { 'nombre': 'observaciones', 'campo': 'Observaciones', 'valor': res.data.observaciones, 'formato': '' }
                    //     ]
                    // } else {
                        if (res.data.vacaciones) {
                            personalNovedadDatos = [
                                { 'nombre': 'fechaDesde', 'campo': 'Desde', 'valor': res.data.fechaDesde, 'formato': 'fecha' },
                                { 'nombre': 'fechaHasta', 'campo': 'Hasta', 'valor': res.data.fechaHasta, 'formato': 'fecha' },
                                { 'nombre': 'periodo', 'campo': 'Periodo', 'valor': res.data.periodo, 'formato': 'periodo_anio' },
                                { 'nombre': 'personal', 'campo': 'Personal', 'valor': res.data.personal, 'formato': '' },
                                { 'nombre': 'tipoNovedad', 'campo': 'Tipo de Novedad', 'valor': res.data.tipoNovedad, 'formato': '' },
                                { 'nombre': 'observaciones', 'campo': 'Observaciones', 'valor': res.data.observaciones, 'formato': '' }
                            ]
                        } else {
                            personalNovedadDatos = [
                                { 'nombre': 'fechaDesde', 'campo': 'Desde', 'valor': res.data.fechaDesde, 'formato': 'fecha' },
                                { 'nombre': 'fechaHasta', 'campo': 'Hasta', 'valor': res.data.fechaHasta, 'formato': 'fecha' },
                                { 'nombre': 'personal', 'campo': 'Personal', 'valor': res.data.personal, 'formato': '' },
                                { 'nombre': 'tipoNovedad', 'campo': 'Tipo de Novedad', 'valor': res.data.tipoNovedad, 'formato': '' },
                                { 'nombre': 'observaciones', 'campo': 'Observaciones', 'valor': res.data.observaciones, 'formato': '' }
                            ]
                        }
                    // }

                    let params = {
                        personalNovedadDatos
                    }
                    commit('SET_DATOS', params);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
};

const getters = {
    getField,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}